import { FormattedMessage } from 'react-intl'
import * as HeaderNavigationSubMenuStyles from '../../../../styles/foundation/HeaderNavigationSubMenu.css'
import { formattedMessageValues } from '../../../../utils/FormattedMessageValues'
import UiLink from '../../../ui/v1/Link'
import { HeaderNavigationSubMenuItem } from './ui/HeaderNavigationSubMenuItem'

type HeaderNavigationSubMenuResourceProps = {
  supportEntity: Queries.Hygraph_GlobalNavigation['support']
  operationalSupportEntry: Queries.Hygraph_GlobalNavigation['operationalSupport']
  specEntity: Queries.Hygraph_GlobalNavigation['spec']
}

export const HeaderNavigationSubMenuResource = ({
  supportEntity,
  operationalSupportEntry,
  specEntity,
}: HeaderNavigationSubMenuResourceProps) => {
  return (
    <>
      <div className={HeaderNavigationSubMenuStyles.Separator({ size: 'standard' })}>
        <div className={HeaderNavigationSubMenuStyles.Headline}>
          <FormattedMessage
            id="components.foundation.header.nav.resource.support.headline"
            defaultMessage="サポート"
            values={{ ...formattedMessageValues }}
          />
        </div>
        <ul
          className={HeaderNavigationSubMenuStyles.Links({
            type: 'simple',
          })}
        >
          {supportEntity?.map((item: Queries.Hygraph_GlobalNavigationStandardItem) => (
            <li key={item.label}>
              <HeaderNavigationSubMenuItem href={item.link} isBlank={item.isBlank} type="simple">
                {item.label}
              </HeaderNavigationSubMenuItem>
            </li>
          ))}
        </ul>
      </div>

      <div className={HeaderNavigationSubMenuStyles.Separator({ size: 'standard' })}>
        <div className={HeaderNavigationSubMenuStyles.Headline}>
          <FormattedMessage
            id="components.foundation.header.nav.resource.operationalSupport.headline"
            defaultMessage="運用支援"
            values={{ ...formattedMessageValues }}
          />
        </div>
        <ul
          className={HeaderNavigationSubMenuStyles.Links({
            type: 'simple',
          })}
        >
          {operationalSupportEntry?.linkListing.map((item: Queries.Hygraph_GlobalNavigationStandardItem) => (
            <li key={item.label}>
              <HeaderNavigationSubMenuItem href={item.link} isBlank={item.isBlank} type="simple">
                {item.label}
              </HeaderNavigationSubMenuItem>
            </li>
          ))}
        </ul>
        {operationalSupportEntry?.thumbnailLink && operationalSupportEntry.thumbnail?.url && (
          <UiLink
            to={operationalSupportEntry.thumbnailLink}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="KARTEサポートサイトへのリンク"
            className={HeaderNavigationSubMenuStyles.Image}
          >
            <img src={operationalSupportEntry.thumbnail.url} alt="" />
          </UiLink>
        )}
      </div>

      <div className={HeaderNavigationSubMenuStyles.Separator({ size: 'standard' })}>
        <div className={HeaderNavigationSubMenuStyles.Headline}>
          <FormattedMessage
            id="components.foundation.header.nav.resource.spec.headline"
            defaultMessage="スペック"
            values={{ ...formattedMessageValues }}
          />
        </div>
        <ul
          className={HeaderNavigationSubMenuStyles.Links({
            type: 'simple',
          })}
        >
          {specEntity.map((item: Queries.Hygraph_GlobalNavigationStandardItem) => (
            <li key={item.label}>
              <HeaderNavigationSubMenuItem href={item.link} isBlank={item.isBlank} type="simple">
                {item.label}
              </HeaderNavigationSubMenuItem>
            </li>
          ))}
        </ul>
      </div>
    </>
  )
}
